'use client';

import { is401Error, is404Error, is500Error } from '@repo/api-clients/utils';
import { Query, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { type ReactNode, useState } from 'react';
import { signOutWithRedirect } from '@/server-actions/sign-out';

export const ReactQueryProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [client] = useState<QueryClient>(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: async (error: unknown, _query: Query<unknown, unknown, unknown>) => {
            if (is404Error(error) || is500Error(error)) {
              await signOutWithRedirect({ redirectTo: '/casino' });
            }

            if (is401Error(error)) {
              await signOutWithRedirect({ redirectTo: '/' + window.location.pathname.split('/').slice(2).join('/') });
            }
          },
        }),
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            retry: false,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={client}>
      <>
        {children}
        {/* <ReactQueryDevtools
          initialIsOpen={false}
          position="bottom"
          buttonPosition="bottom-right"
        /> */}
      </>
    </QueryClientProvider>
  );
};
